import angular from 'angular'
import analyticsController from './analytics.ctrl.js'
import analyticsTemplate from './analytics.html'

import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'

export default angular.module('analytics', ['ui.router'])
  .config(function ($httpProvider, $stateProvider) {
    'ngInject'

    $stateProvider.state('app.analytics', {
      url: '/analytics',
      resolve: {
        analytics: (Companies) => {
          'ngInject'
          return Companies.fetchAnalytics()
        }
      },
      views: {
        content: {
          controller: analyticsController,
          controllerAs: 'a',
          template: analyticsTemplate
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
